<template>
  <div>
    <div
      class="tabs"
      v-if="tabs.length > 1"
    >
      <button
        type="button"
        role="tab"
        class="flex flex-align-center flex-justify-center"
        v-for="(tab, t) in tabs"
        :key="`tab-${t}`"
        :class="{'active': activeTab === t, [tab.warningClass]: tab.hasWarning}"
        @click="switchTab(t, $event)"
      >
        <span v-html="tab.title"></span>
        <span v-if="tab.hasWarning">
          <SvgWarning
            size="15px"
            class="block"
            style="margin-left: .25em;"
          ></SvgWarning>
        </span>
      </button>
    </div>

    <div class="panels">
      <slot v-bind="{ switchTab: switchTab }"/>
    </div>
  </div>
</template>

<script>
import SvgWarning from './SvgWarning';

export default {
  name: 'Tabs',

  components: {
    SvgWarning,
  },

  props: {
    defaultTab: {
      type: Number,
      default: 0,
    },

    onSwitch: {
      type: Function,
    },
  },

  data() {
    return {
      activeTab: 0,
      tabs: [],
    };
  },

  mounted() {
    this.$nextTick(() => {
      const interval = setInterval(() => {
        if(this.$children.length > 0) {
          this.tabs = this.children();

          this.switchTab(this.defaultTab);

          clearInterval(interval);
        }
      }, 50);
    });
  },

  methods: {
    children() {
      return this.$children.filter(c => c.constructor.options.name === 'Tab');
    },

    switchTab(index, e) {
      const lastActive = this.activeTab;

      this.activeTab = index;

      for(let i = 0; i < this.tabs.length; i++) {
        this.tabs[i].isActive = i === index;
      }

      this.onSwitch && this.onSwitch(e, this.activeTab, lastActive);
    },
  },
}
</script>

<style scoped>
.tabs {
  display: flex;
  line-height: 1;
}
.tabs > button {
  background-color: transparent;
  border: 0;
  color: #00549d;
  font-weight: 400;
  padding-bottom: .75em;
  padding-top: .75em;
  width: 50%;
  -webkit-appearance: none;
}
@media (min-width: 768px) {
  .tabs > button {
    padding-left: 1.25em;
    padding-right: 1.25em;
    width: auto;
  }
}
.tabs > button:hover {
  color: #111111;
}
.tabs > button:focus {
  color: #111111;
  outline: none;
}
.tabs > button:focus-visible {
  outline: 2px solid #979797;
  outline-offset: -2px;
}
.tabs > .active {
  background-color: #F2F3F4;
  color: #00549d;
}

.panels {
  background-color: #F2F3F4;
  padding: 1.5em;
  position: relative;
}
>>> .panel {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  visibility: hidden;
}
>>> .panels > .active {
  opacity: 1;
  position: relative;
  top: auto;
  visibility: visible;
  z-index: 10;
}
</style>
